// Featured Blog block schema - Showcase a single blog post with Read More
export const featuredBlogSchema = {
  type: 'featured-blog',
  label: 'Featured Blog',
  description: 'Showcase a blog post with a Read More button',
  icon: 'Newspaper',
  defaultContent: {
    blogId: '',
    buttonText: 'Read More',
    showExcerpt: true,
    layout: 'imageLeft', // 'imageLeft' | 'imageRight'
    style: {},
  },
};
